/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, total: NonNullable<unknown>, minutes: NonNullable<unknown> }} Bookings_Sessions_LeftInputs */

const en_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} of ${i?.total} sessions left · ${i?.minutes} min`)
};

const es_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} de ${i?.total} sesiones restantes · ${i?.minutes} min`)
};

const de_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch ${i?.remaining} von ${i?.total} Golfstunden · ${i?.minutes} Min.`)
};

const zh_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`剩余 ${i?.remaining}/${i?.total} 节课 · ${i?.minutes} 分钟`)
};

const ar_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تبقّى ${i?.remaining} من ${i?.total} جلسة · ${i?.minutes} دقيقة`)
};

const fr_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} séance(s) restante(s) sur ${i?.total} · ${i?.minutes} min`)
};

const vi_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Còn ${i?.remaining} trên ${i?.total} buổi · ${i?.minutes} phút`)
};

const sw_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vimesalia vipindi ${i?.remaining} kati ya ${i?.total} · dak ${i?.minutes}`)
};

const th_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เหลือ ${i?.remaining} จาก ${i?.total} ครั้ง · ${i?.minutes} นาที`)
};

const bs_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} od ${i?.total} sesija preostalo · ${i?.minutes} min`)
};

const ja_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`残り ${i?.remaining}/${i?.total} 回 · ${i?.minutes} 分`)
};

const ko_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}회 중 ${i?.remaining}회 남음 · ${i?.minutes}분`)
};

const pt_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restam ${i?.remaining} de ${i?.total} sessões · ${i?.minutes} min`)
};

const it_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} sessioni rimaste su ${i?.total} · ${i?.minutes} min`)
};

const sv_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} av ${i?.total} sessioner kvar · ${i?.minutes} min`)
};

const nl_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} van ${i?.total} sessies over · ${i?.minutes} min`)
};

const da_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} af ${i?.total} sessioner tilbage · ${i?.minutes} min`)
};

const nb_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} av ${i?.total} økter igjen · ${i?.minutes} min`)
};

const fi_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining}/${i?.total} kertaa jäljellä · ${i?.minutes} min`)
};

const pl_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pozostało ${i?.remaining} z ${i?.total} lekcji · ${i?.minutes} min`)
};

const ru_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Осталось ${i?.remaining} из ${i?.total} занятий · ${i?.minutes} мин`)
};

const tr_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} dersten ${i?.remaining} ders kaldı · ${i?.minutes} dk`)
};

const hi_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} में से ${i?.remaining} सत्र शेष · ${i?.minutes} मिनट`)
};

const id_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sisa ${i?.remaining} dari ${i?.total} sesi · ${i?.minutes} menit`)
};

const ms_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Baki ${i?.remaining} daripada ${i?.total} sesi · ${i?.minutes} min`)
};

const cs_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zbývá ${i?.remaining} z ${i?.total} lekcí · ${i?.minutes} min`)
};

const el_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Απομένουν ${i?.remaining} από ${i?.total} μαθήματα · ${i?.minutes} λεπτά`)
};

const he_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`נותרו ${i?.remaining} מתוך ${i?.total} מפגשים · ${i?.minutes} דק׳`)
};

const af_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining} van ${i?.total} sessies oor · ${i?.minutes} min`)
};

const hu_bookings_sessions_left = /** @type {(inputs: Bookings_Sessions_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.remaining}/${i?.total} alkalom van hátra · ${i?.minutes} perc`)
};

/**
* | output |
* | --- |
* | "{remaining} of {total} sessions left · {minutes} min" |
*
* @param {Bookings_Sessions_LeftInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const bookings_sessions_left = /** @type {((inputs: Bookings_Sessions_LeftInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bookings_Sessions_LeftInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_bookings_sessions_left(inputs)
	if (locale === "de") return de_bookings_sessions_left(inputs)
	if (locale === "zh") return zh_bookings_sessions_left(inputs)
	if (locale === "ar") return ar_bookings_sessions_left(inputs)
	if (locale === "fr") return fr_bookings_sessions_left(inputs)
	if (locale === "vi") return vi_bookings_sessions_left(inputs)
	if (locale === "sw") return sw_bookings_sessions_left(inputs)
	if (locale === "th") return th_bookings_sessions_left(inputs)
	if (locale === "bs") return bs_bookings_sessions_left(inputs)
	if (locale === "ja") return ja_bookings_sessions_left(inputs)
	if (locale === "ko") return ko_bookings_sessions_left(inputs)
	if (locale === "pt") return pt_bookings_sessions_left(inputs)
	if (locale === "it") return it_bookings_sessions_left(inputs)
	if (locale === "sv") return sv_bookings_sessions_left(inputs)
	if (locale === "nl") return nl_bookings_sessions_left(inputs)
	if (locale === "da") return da_bookings_sessions_left(inputs)
	if (locale === "nb") return nb_bookings_sessions_left(inputs)
	if (locale === "fi") return fi_bookings_sessions_left(inputs)
	if (locale === "pl") return pl_bookings_sessions_left(inputs)
	if (locale === "ru") return ru_bookings_sessions_left(inputs)
	if (locale === "tr") return tr_bookings_sessions_left(inputs)
	if (locale === "hi") return hi_bookings_sessions_left(inputs)
	if (locale === "id") return id_bookings_sessions_left(inputs)
	if (locale === "ms") return ms_bookings_sessions_left(inputs)
	if (locale === "cs") return cs_bookings_sessions_left(inputs)
	if (locale === "el") return el_bookings_sessions_left(inputs)
	if (locale === "he") return he_bookings_sessions_left(inputs)
	if (locale === "af") return af_bookings_sessions_left(inputs)
	if (locale === "hu") return hu_bookings_sessions_left(inputs)
	return en_bookings_sessions_left(inputs)
});